import Fingerprint2 from 'fingerprintjs2'
import UAParser from 'ua-parser-js'

/**
 * Returns browser name.
 *
 * @returns {String}
 */
export const browser = () => {
    const parser = new UAParser()

    return parser.getBrowser().name
}

/**
 * Browser finger print hashing
 *
 * @returns {String}
 */
export const fingerPrintHash = async () => {
    const options = {
        excludes: {
            userAgent: true,
            screenResolution: true,
            availableScreenResolution: true,
            pixelRatio: true,
        },
    }

    const hash = await Fingerprint2
        .getPromise(options)
        .then((components) => {
            const values = components.map((component) => component.value)

            return btoa(values.join('')).substring(0, 32)
        })

    return hash
}

/**
 * Returns Operating system for Browser.
 *
 * @returns {String}
 */
export const os = () => {
    const parser = new UAParser()

    return parser.getOS().name
}
